<section class="vo-card" aria-labelledby="step2-title">
  <header class="vo-card__head">
    <h2 class="vo-card__title" id="step2-title">Ihre Auszugsadresse</h2>
    <p class="vo-card__sub">Von wo ziehen Sie aus?</p>
  </header>

  <form class="vo-grid" [formGroup]="draftInquiryForm" novalidate>
    <div class="vo-field vo-field--full">
      <label class="vo-label" for="from_address">Auszugsadresse</label>
      <div class="vo-input-icon">
        <app-icon name="map-pin" class="vo-input-icon__icon"/>
        <input #fromAddressInput id="from_address" type="text" class="vo-input" formControlName="address"
               placeholder="Strasse &amp; Hausnummer — Adresse suchen" autocomplete="off"
               [class.is-invalid]="hasError('address')">
        <app-google-places-autocomplete
          [forInput]="fromAddressInput"
          [countries]="[draftInquiryForm.controls.country.value.toLowerCase()]"
          (placeSelected)="onAddressPlaceSelected($event)"/>
      </div>

      <div class="vo-address__row vo-address__row--country">
        <div class="vo-address__cell">
          <input #fromZipInput id="from_zip" type="text" class="vo-input" formControlName="zip"
                 placeholder="PLZ" aria-label="PLZ" autocomplete="off" [class.is-invalid]="hasError('zip')">
          <app-google-places-autocomplete
            [forInput]="fromZipInput"
            [countries]="[draftInquiryForm.controls.country.value.toLowerCase()]"
            [types]="['postal_code']"
            [minQueryLength]="2"
            (placeSelected)="onZipPlaceSelected($event)"/>
        </div>
        <div class="vo-address__cell">
          <input #fromCityInput id="from_city" type="text" class="vo-input" formControlName="city"
                 placeholder="Ort" aria-label="Ort" autocomplete="off" [class.is-invalid]="hasError('city')">
          <app-google-places-autocomplete
            [forInput]="fromCityInput"
            [countries]="[draftInquiryForm.controls.country.value.toLowerCase()]"
            [types]="['locality']"
            [minQueryLength]="2"
            (placeSelected)="onCityPlaceSelected($event)"/>
        </div>
        <div class="vo-address__cell vo-address__country">
          <select id="from_country" class="vo-select" formControlName="country" aria-label="Land">
            <option *ngFor="let option of countryOptions" [value]="option.value">{{ option.label }}</option>
          </select>
        </div>
      </div>

      <p class="vo-error" *ngIf="hasError('address') || hasError('zip') || hasError('city')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte Strasse und Hausnummer, PLZ und Ort angeben
      </p>
    </div>

    <div class="vo-field vo-field--full">
      <span class="vo-label" id="step2-object-type">Art des Objekts</span>
      <div class="vo-chips" role="group" aria-labelledby="step2-object-type">
        <button *ngFor="let option of objectTypeOptions" type="button" class="vo-chip"
                [class.is-selected]="isObjectTypeActive(option.value)"
                [class.is-invalid]="hasError('object_type')"
                [attr.aria-pressed]="isObjectTypeActive(option.value)"
                (click)="selectObjectType(option.value)">
          <app-icon [name]="option.lucideIcon"/>
          {{ option.label }}
        </button>
      </div>
      <p class="vo-error" *ngIf="hasError('object_type')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte wählen Sie eine Option aus
      </p>
    </div>

    <div class="vo-field">
      <label class="vo-label" for="from_floor">Etage</label>
      <select id="from_floor" class="vo-select" formControlName="floor" [class.is-invalid]="hasError('floor')">
        <option value="" disabled>Bitte wählen</option>
        <option *ngFor="let option of floorOptions" [value]="option">{{ option | inquiryFloor }}</option>
      </select>
      <p class="vo-error" *ngIf="hasError('floor')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte wählen Sie eine Option aus
      </p>
    </div>

    <div class="vo-field">
      <span class="vo-label" id="step2-lift">Lift vorhanden?</span>
      <div class="vo-seg" role="group" aria-labelledby="step2-lift">
        <button type="button" class="vo-seg__opt"
                [class.is-selected]="isHasLiftOptionSelected(true)"
                [class.is-invalid]="hasError('has_lift')"
                [attr.aria-pressed]="isHasLiftOptionSelected(true)"
                (click)="selectHasLift(true)">
          <app-icon name="arrow-up-down" [size]="16"/>
          Mit Lift
        </button>
        <button type="button" class="vo-seg__opt"
                [class.is-selected]="isHasLiftOptionSelected(false)"
                [class.is-invalid]="hasError('has_lift')"
                [attr.aria-pressed]="isHasLiftOptionSelected(false)"
                (click)="selectHasLift(false)">
          <app-icon name="ban" [size]="16"/>
          Ohne Lift
        </button>
      </div>
      <p class="vo-error" *ngIf="hasError('has_lift')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte wählen Sie eine Option aus
      </p>
    </div>

    <div class="vo-field">
      <label class="vo-label" for="rooms">Anzahl Zimmer</label>
      <select id="rooms" class="vo-select" formControlName="rooms" [class.is-invalid]="hasError('rooms')">
        <option value="" disabled>Bitte wählen</option>
        <option *ngFor="let option of roomOptions" [value]="option">{{ option | inquiryRooms }}</option>
      </select>
      <p class="vo-error" *ngIf="hasError('rooms')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte wählen Sie eine Option aus
      </p>
    </div>

    <div class="vo-field">
      <label class="vo-label" for="square_meters">Wohnfläche in m²</label>
      <input id="square_meters" type="number" class="vo-input" formControlName="square_meters"
             placeholder="z.B. 75" min="10" max="500" [class.is-invalid]="hasError('square_meters')">
      <p class="vo-error" *ngIf="hasError('square_meters')">
        <app-icon name="circle-alert" [size]="14"/>
        Wohnfläche muss zwischen 10 und 500 m² liegen
      </p>
    </div>
  </form>
</section>

<app-inquiry-step-nav (back)="goBack()" (next)="onSubmit()"/>
